export const APP_NAME = 'NaturAssist'

export const NAV_ITEMS = [
  { path: '/dashboard', label: 'Dashboard', icon: 'LayoutDashboard', permission: null },
  { path: '/clients', label: 'Clients', icon: 'Users', permission: { resource: 'clients', action: 'read' } },
  { path: '/examination', label: 'Examination', icon: 'Stethoscope', permission: { resource: 'clients', action: 'write' } },
  { path: '/care-plans', label: 'Care Plans', icon: 'Heart', permission: { resource: 'care_plans', action: 'read' } },
  { path: '/therapies', label: 'Therapies', icon: 'Calendar', permission: { resource: 'therapies', action: 'read' } },
  { path: '/sessions', label: 'Sessions', icon: 'Archive', permission: { resource: 'sessions', action: 'read' } },
  { path: '/websites', label: 'Website', icon: 'Globe', permission: { requireAdmin: true } },
  { path: '/organization', label: 'Organization', icon: 'Settings', permission: { requireAdmin: true } },
  { path: '/backup-restore', label: 'Backup & Restore', icon: 'Database', permission: { requireAdmin: true } },
  // GDPR Management is now master admin only - removed from regular navigation
  { path: '/support', label: 'Support', icon: 'HelpCircle', permission: null },
  { path: '/forum', label: 'Forum', icon: 'MessageSquare', permission: null },
  { path: '/invitations', label: 'Invitations', icon: 'Mail', permission: null },
]

export const EXAM_SECTIONS = [
  {
    id: 'personal',
    title: 'Personal Information',
    fields: [
      { name: 'firstName', label: 'First Name', type: 'text', required: true },
      { name: 'lastName', label: 'Last Name', type: 'text', required: true },
      { name: 'dateOfBirth', label: 'Date of Birth', type: 'date', required: true },
      { name: 'gender', label: 'Gender', type: 'select', options: ['Male', 'Female'], required: true },
      { name: 'phone', label: 'Phone Number', type: 'tel' },
      { name: 'email', label: 'Email', type: 'email' },
    ]
  },
  {
    id: 'medical',
    title: 'Medical History',
    fields: [
      { name: 'currentMedications', label: 'Current Medications', type: 'textarea' },
      { name: 'allergies', label: 'Allergies', type: 'textarea' },
      { name: 'pastSurgeries', label: 'Past Surgeries', type: 'textarea' },
      { name: 'familyHistory', label: 'Family Medical History', type: 'textarea' },
      { name: 'chronicConditions', label: 'Chronic Conditions', type: 'textarea' },
    ]
  },
  {
    id: 'lifestyle',
    title: 'Lifestyle & Wellness',
    fields: [
      // diet, exercise, sleep are handled separately by WellnessHabitsSection component
      { name: 'stressLevel', label: 'Stress Level', type: 'select', options: ['Low', 'Moderate', 'High', 'Very High'] },
      { name: 'alcohol', label: 'Alcohol Consumption', type: 'select', options: ['None', 'Occasional', 'Regular', 'Heavy'] },
      { name: 'smoking', label: 'Smoking Status', type: 'select', options: ['Non-smoker', 'Former smoker', 'Current smoker'] },
    ]
  },
  {
    id: 'goals',
    title: 'Health Goals',
    fields: [
      { name: 'primaryGoals', label: 'Primary Health Goals', type: 'textarea', required: true },
      { name: 'expectations', label: 'Treatment Expectations', type: 'textarea' },
      { name: 'previousTreatments', label: 'Previous Naturopathic Treatments', type: 'textarea' },
    ]
  },
  {
    id: 'vitals',
    title: 'Vital Signs',
    description: 'Capture baseline vitals to monitor changes over time.',
    fields: [
      { name: 'bloodPressure', label: 'Blood Pressure (mmHg)', type: 'text', placeholder: 'e.g. 118/76', required: true },
      { name: 'heartRate', label: 'Heart Rate (bpm)', type: 'number', required: true },
      { name: 'respiratoryRate', label: 'Respiratory Rate (breaths/min)', type: 'number' },
      { name: 'temperature', label: 'Temperature (°C)', type: 'number', step: '0.1' },
      { name: 'oxygenSaturation', label: 'SpO₂ (%)', type: 'number' },
      { name: 'weight', label: 'Weight (kg)', type: 'number', step: '0.1' },
      { name: 'height', label: 'Height (cm)', type: 'number', step: '0.1' },
      { name: 'bmi', label: 'BMI', type: 'number', step: '0.1', readOnly: true },
    ]
  },
  {
    id: 'questionnaire',
    title: 'Questionnaire & Charting',
    description: 'Document bespoke case questions and structured answers.',
    fields: [],
  },
  {
    id: 'consent',
    title: 'Client Consent',
    description: 'Obtain client consent before saving their information.',
    fields: [
      { name: 'clientConsent', label: 'Client Consent', type: 'checkbox', required: true },
      { name: 'consentDate', label: 'Consent Date', type: 'date', required: true },
      { name: 'consentWitness', label: 'Witness Name (Optional)', type: 'text' },
    ]
  }
]

export const QUESTION_TYPE_OPTIONS = [
  { value: 'choice', label: 'Yes / No / Maybe / Not Known' },
  { value: 'text', label: 'Open-ended (Text)' },
]

export const CHOICE_OPTIONS = ['Yes', 'No', 'Maybe', 'Not Known']

